import React, { Component } from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/navBar";
import Input from "../components/levty-ui/input";
import Footer from "../components/footer";
import LoadingButton from "../components/levty-ui/loadingButton";
import MessageModal from "../components/modals/messageModal";
import CarrerDataModal from "../components/modals/carrerDataModal";
import CarrerEmailTokenModal from "../components/modals/carrerEmailTokenModal";
import Metatags from "../components/metatags";
import SessionListener from "../utils/session-listener.js";


import { getBase64 } from "../utils/files";
import { getCarrersAuthentication, isAuthenticatedCarrers, renewAccessToken } from "../utils/authentication";
import carrerService from "../services/carrerService";

class Talento extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkBoxArray: [
        { name: "Desenvolvimento", checked: false },
        { name: "Design", checked: false },
        { name: "Infraestrutura", checked: false },
        { name: "Corporativo", checked: false },
        { name: "Marketing", checked: false },
        { name: "Negócios", checked: false }
      ],
      file: null,
      fileName: "",
      fileError: false,
      isLoading: false,
      authName: null,
      authEmail: null,
      accessToken: "",
      showMessagemModal: false,
      showSignUpModals: false,
      showErrorModal: false,
      showEmailErrorModal: false
    }
  }

  async componentDidMount() {
    SessionListener.onInsertedItem(prop => {
      if (prop === 'carrersAuthentication') {
        window.location.reload();
      }
    });
    SessionListener.onGettingSession(prop => {
      if (prop === 'carrersAuthentication') {
        window.location.reload();
      }
    });
    SessionListener.askForSession();

    let error = this.getUrlParameter("error");
    if (error) {
      error === "A conta deve possuir um e-mail verificado." ? this.setState({ isLoading: false, showEmailErrorModal: true }) : this.setState({ isLoading: false, showErrorModal: true });
    } else if (this.getUrlParameter("accessToken")) {
      await renewAccessToken(this.getUrlParameter("accessToken"));
    }
    let Auth = getCarrersAuthentication();
    if (Auth) {
      this.setState({
        authName: Auth.name,
        authEmail: Auth.email,
        accessToken: Auth.accessToken
      });
    }

    this.setState({ showSignUpModals: !isAuthenticatedCarrers() });

    if (window.location.href.includes('?accessToken'))
      window.location.href = window.location.href.slice(
        0,
        window.location.href.indexOf('?accessToken')
      );
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.showSignUpModals !== this.state.showSignUpModals) {
      let Auth = getCarrersAuthentication();
      if (Auth) {
        this.setState({
          authName: Auth.name,
          authEmail: Auth.email,
          accessToken: Auth.accessToken
        });
      }
    }
  }

  getUrlParameter(name) {
    // obtem os parametros no caso de url proveniente de alguma ferramenta de divulgação 
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  handleClickCheckbox = (e) => {
    let { checkBoxArray } = this.state;

    let index = checkBoxArray.findIndex(x => x.name === e.target.id);

    checkBoxArray[index] = { name: e.target.id, checked: e.target.checked };
    this.setState({ checkBoxArray });
  }

  handleFileInput = (e) => {
    if (e.target.files[0]) {
      this.setState({ fileName: e.target.files[0].name });
    }

    if (e.target.files[0]) {

      let fileFormat = e.target.files[0].type;
      let fileSizeMB = (e.target.files[0].size) / (1024 * 1024);

      if (fileFormat !== "application/pdf") {
        this.setState({ fileError: true, fileErrorMessage: "Formato de arquivo não suportado" });
        return false;
      }
      if (fileSizeMB > 5) {
        this.setState({ fileError: true, fileErrorMessage: "Tamanho máximo do arquivo deverá ser 5MB" });
        return false;
      }

      this.setState({ fileError: false, fileErrorMessage: "", file: e.target.files[0] });
      return true;
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    try {
      const { file, checkBoxArray, fileName, accessToken } = this.state;
      let data = {};

      if (file) {
        this.setState({ isLoading: true });
        const reader = new FileReader();
        reader.readAsDataURL(file);

        data.interests = checkBoxArray
          .filter(check => check.checked === true)
          .map(check => check.name);

        getBase64(file).then(async result => {

          if (result) {
            data = {
              ...data,
              resume: {
                name: fileName,
                base64: result
              },
              accessToken
            };

            if (await carrerService.submitResume(data)) {
              this.setState({ isLoading: false, showMessagemModal: true });
            } else {
              this.setState({ isLoading: false, showErrorModal: true });
            }
          }
          else {
            throw Object.assign(
              new Error("Há um problema com o seu arquivo."),
              { code: 402 }
            );
          }
        })
          .catch(err => {
            console.log(err);
            this.setState({ isLoading: false });
            this.setState({ fileError: true, fileErrorMessage: err });
          })
      }
    } catch {
      this.setState({ isLoading: false });
    }
  }

  handleCloseMessageModal = () => {
    this.setState({ showMessagemModal: false });
  }

  handleCloseDataModal = () => {
    if (isAuthenticatedCarrers()) {
      this.setState({ showSignUpModals: false });
    } else {
      this.props.history.push("/carreiras/vagas");
    }

  }

  handleCloseTokenModal = () => {
    this.setState(state => {
      return {
        showSignUpModals: false,
        isAuthenticated: isAuthenticatedCarrers()
      };
    });
    let Auth = getCarrersAuthentication();
    if (Auth && isAuthenticatedCarrers()) {
      this.setState({
        authName: Auth.name,
        authEmail: Auth.email,
        accessToken: Auth.accessToken,
        waitingEmailToken: false,
        file: null,
        fileName: "Selecione seu currículo",
      });
    } else {
      this.setState({
        waitingEmailToken: true
      });
      this.props.history.push("/carreiras/vagas")
    }
  }

  handleEmailTokenModal = (value) => {
    this.setState({ waitingEmailToken: value });
  }

  handleCloseMessageModal = () => {
    this.setState({ showMessagemModal: false });
  }

  handleCloseErrorModal = () => {
    this.setState({ showErrorModal: false });
  }

  handleCloseErrorErrorModal = () => {
    this.setState({ showEmailErrorModal: false, showSignUpModals: true });
  }

  handleSignOut = () => {
    this.setState({
      showSignUpModals: true,
      waitingEmailToken: false,
      showEmailErrorModal: false,
      showErrorModal: false
    });
  }

  render() {
    const { checkBoxArray, fileName, fileError, fileErrorMessage, isLoading, authEmail, authName, file, showMessagemModal, showSignUpModals, waitingEmailToken, showErrorModal, showEmailErrorModal } = this.state;

    return (
      <>
        <Metatags
          title="Talento | LEVTY"
          description="Mostre seu talento. Cadastre seu currículo. Se houver alguma vaga compatível com o seu perfil, vamos entrar em contato com você."
          url={window.location.href}
          canonical="/carreiras/talento"
        />
        <NavBar />
        <main>
          <div   translate="no" className="notranslate lev-talent animated fadeIn slow">
            <section className="notranslate lev-section-talent">
              <div   translate="no" className="notranslate container">
                <div   translate="no" className="notranslate row justify-content-between">

                  <div   translate="no" className="notranslate col-lg-5">
                    <div   translate="no" className="notranslate lev-talent-to-jobs">
                      <Link className="notranslate btn btn-link lev-btn-link-back" to="/carreiras/vagas">
                        Vagas abertas
                      </Link>
                    </div>
                    <h1   translate="no" className="notranslate mb-4 lev-talent-title">Mostre <br className="notranslate d-none d-lg-block" />seu talento</h1>
                    <p   translate="no" className="notranslate lead">Cadastre seu currículo. Se houver alguma vaga compatível com o
                      seu perfil, vamos entrar em contato com você.</p>

                  </div>

                  <div   translate="no" className="notranslate col-lg-5">
                    <form id="talent-form" onSubmit={this.handleSubmit}>
                      <h2   translate="no" className="notranslate h5 mb-3">Informações de contato</h2>
                      <div   translate="no" className="notranslate lev-rev-info-talent">
                        <p   translate="no" className="notranslate text-muted" style={{ "fontSize": ".9375rem" }}>Revise suas informações pessoais.</p>
                        <p   translate="no" className="notranslate btn btn-sm btn-link" onClick={this.handleSignOut}>Alterar dados</p>
                      </div>

                      <div   translate="no" className="notranslate mb-3">

                        <div   translate="no" className="notranslate form-group">
                          <Input
                            id="nameTalento"
                            label="Nome completo"
                            type="text"
                            backgroundColor="#E7E8EE"
                            readOnly={true}
                            callBackFunction={() => { }}
                            value={authName}
                          />
                        </div>

                      </div>
                      <div   translate="no" className="notranslate form-group">
                        <div   translate="no" className="notranslate mb-4">
                          <Input
                            id="emailTalento"
                            label="Email"
                            type="email"
                            backgroundColor="#E7E8EE"
                            readOnly={true}
                            callBackFunction={() => { }}
                            value={authEmail}
                          />
                        </div>
                      </div>
                      <h2   translate="no" className="notranslate h5 mb-1">Suas áreas de interesse</h2>
                      <p   translate="no" className="notranslate text-muted" style={{ "fontSize": ".9375rem" }}>Conte para nós em quais áreas você gostaria de trabalhar.</p>
                      <div   translate="no" className="notranslate row mb-4">
                        <div   translate="no" className="notranslate col-12">
                          <div   translate="no" className="notranslate checkboxGrid">
                            {checkBoxArray.map(item => {
                              return (
                                <div   translate="no" className="notranslate checkbox path" key={item.name}>
                                  <input type="checkbox" checked={this.teste} onClick={this.handleClickCheckbox} id={item.name} />
                                  <svg viewBox="0 0 21 21">
                                    <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                                  </svg>
                                  <span>{item.name}</span>
                                </div>
                              )
                            })
                            }
                          </div>
                        </div>
                      </div>

                      <h2   translate="no" className="notranslate h5 mb-1">Seu currículo</h2>
                      <p   translate="no" className="notranslate text-muted mb-3 lev-form-subtitle">Com seu currículo, poderemos determinar as áreas
                        mais adequadas às suas habilidades e aos seus interesses.</p>
                      <p   translate="no" className="notranslate text-muted mb-3 lev-form-subtitle">Envie seu currículo no formato PDF com no máximo 5 MB.</p>
                      <div   translate="no" className="notranslate lev-input-file-container pb-2 mb-4">
                        <input type="file" id="curriculum" name="curriculum" className="notranslate lev-input-group lev-input-file" onChange={this.handleFileInput} />
                        <div   translate="no" className="notranslate lev-input-wrapper d-flex align-items-center">
                          <label htmlFor="curriculum" className="notranslate lev-input-file-trigger mb-0 mr-3">
                            <img className="notranslate lev-input-file-trigger-icon" src={process.env.PUBLIC_URL + "/images/icons/attach_file.svg"} alt="LEVTY" />
                          </label>
                          <span   translate="no" className="notranslate lev-input-file-return">{fileName === "" ? "Selecione seu currículo" : fileName}</span>
                        </div>
                        {fileError ? (<span   translate="no" className="notranslate lev-input-file-return" style={{ "color": "red" }}>{fileErrorMessage}</span>) : null}
                      </div>

                      {!showSignUpModals ? (
                        <>
                          <LoadingButton
                            label="Enviar currículo"
                            isLoading={isLoading}
                            onlyDisable={((file === null) || !(checkBoxArray.some(box => box.checked === true)))}
                            type="submit"
                          />
                        </>
                      ) : null}
                    </form>
                  </div>

                </div>
              </div>
            </section>
          </div>
        </main>
        {showSignUpModals && !waitingEmailToken && !showEmailErrorModal && !showErrorModal &&
          <CarrerDataModal
            handleClose={this.handleCloseDataModal}
            handleEmailTokenModal={this.handleEmailTokenModal}
            abs={true}
          />
        }
        {showSignUpModals && waitingEmailToken &&
          <CarrerEmailTokenModal
            handleClose={this.handleCloseTokenModal}
            handleEmailTokenModal={this.handleEmailTokenModal}
          />
        }
        {showMessagemModal &&
          <MessageModal
            title="Tudo certo!"
            subtitle="Currículo recebido com sucesso! Em caso de aprovação, entraremos em contato. Boa sorte!"
            buttonClass="primary"
            // onClick={this.handleCloseMessageModal} 
            onClick={() => { window.location.pathname = "/" }}
          />
        }
        {showErrorModal &&
          <MessageModal
            title="Oops"
            subtitle="Erro ao enviar seus dados. Tente novamente mais tarde"
            buttonClass="danger"
            onClick={this.handleCloseErrorModal} />
        }
        {showEmailErrorModal &&
          <MessageModal
            title="Desculpe, mas esta conta não fornece um e-mail."
            subtitle="Por favor entre com uma conta com e-mail ou cadastre-se pelo nosso site."
            buttonClass="danger"
            onClick={this.handleCloseErrorErrorModal} />
        }
        <Footer />
      </>
    );
  }
}

export default Talento;